import { Flex, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import type { DefaultProps } from 'typings'
import { RuleStack } from '../RuleStack'
import { AddConditionButton } from './AddButton'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from '../Section'

export function Conditions(props: DefaultProps) {
  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <SectionTitle>
            <FormattedMessage id="admin/promotions.form.conditions.title" />
          </SectionTitle>
          <Text tone="secondary">
            <FormattedMessage id="admin/promotions.form.conditions.subtitle" />
          </Text>
        </Flex>
      </SectionHeader>
      <SectionContent>
        <RuleStack>{props.children}</RuleStack>
        <AddConditionButton />
      </SectionContent>
    </Section>
  )
}
